export default class extends HTMLElement {
  connectedCallback () {
    this.querySelectorAll('a').forEach((link) => {
      if (document.location.pathname.startsWith(link.pathname) && !link.getAttribute('href').startsWith('http')) {
        link.classList.add('bg-transparent', 'text-cs-main-500', 'font-bold', '!border-l-2', '!border-l-cs-main-500')
      }
    })
  }
}
